(function () {
  'use strict';

  var TILES = {
    // OSM's own tile server: keyless, free, and explicitly permitted for low-volume
    // sites under the OSMF tile usage policy. Default for that reason.
    osm: {
      url: 'https://tile.openstreetmap.org/{z}/{x}/{y}.png',
      options: {
        maxZoom: 19,
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
      }
    },
    // Cleaner grey basemap. Third-party endpoint, so treat it as the nice-to-have.
    light: {
      url:
        'https://services.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}',
      options: {
        maxZoom: 16,
        attribution: 'Tiles &copy; Esri &mdash; Esri, DeLorme, NAVTEQ'
      }
    }
  };

  var COUNTRY_LABELS = { CZ: 'Česko', SK: 'Slovensko', PL: 'Polsko', DE: 'Německo', AT: 'Rakousko', HU: 'Maďarsko' };

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }

  // Accepts what Google Maps puts on the clipboard: "48.049769, 18.656972".
  // Also tolerates semicolons, whitespace-only separators and stray parentheses.
  function parseGps(raw) {
    if (!raw) return null;
    var parts = String(raw)
      .replace(/[()]/g, '')
      .split(/[;,]|\s+/)
      .filter(function (p) {
        return p !== '';
      });
    if (parts.length < 2) return null;
    var lat = parseFloat(parts[0]);
    var lng = parseFloat(parts[1]);
    if (!isFinite(lat) || !isFinite(lng)) return null;
    if (lat < -90 || lat > 90 || lng < -180 || lng > 180) return null;
    return [lat, lng];
  }

  function stripDiacritics(value) {
    var s = String(value || '').toLowerCase();
    return s.normalize ? s.normalize('NFD').replace(/[̀-ͯ]/g, '') : s;
  }

  function pluralize(count, labels) {
    if (count === 1) return labels.count_one;
    if (count >= 2 && count <= 4) return labels.count_few;
    return labels.count_many;
  }

  function Locator(root) {
    this.root = root;
    this.map = null;
    this.markers = [];
    this.activeId = null;
    this.country = 'all';
    this.query = '';

    var dataEl = root.querySelector('[data-kekse-locator-data]');
    var parsed = [];
    try {
      parsed = JSON.parse(dataEl ? dataEl.textContent : '[]');
    } catch (e) {
      parsed = [];
    }

    this.labels = {};
    try {
      this.labels = JSON.parse(root.getAttribute('data-labels') || '{}');
    } catch (e) {
      this.labels = {};
    }

    // Places without usable coordinates are dropped rather than silently pinned at 0,0.
    this.places = parsed
      .map(function (place) {
        var coords = parseGps(place.gps);
        if (!coords) return null;
        place.lat = coords[0];
        place.lng = coords[1];
        place.haystack = stripDiacritics(
          [place.name, place.street, place.city, place.zip, place.note].join(' ')
        );
        return place;
      })
      .filter(Boolean);

    this.els = {
      controls: root.querySelector('[data-locator-controls]'),
      search: root.querySelector('[data-locator-search]'),
      filters: root.querySelector('[data-locator-filters]'),
      count: root.querySelector('[data-locator-count]'),
      list: root.querySelector('[data-locator-list]'),
      empty: root.querySelector('[data-locator-empty]'),
      map: root.querySelector('[data-locator-map]')
    };

    if (!this.places.length) {
      if (this.els.empty) {
        this.els.empty.textContent = 'Zatím tu nejsou žádné prodejny.';
        this.els.empty.hidden = false;
      }
      return;
    }

    if (this.els.controls) this.els.controls.hidden = false;
    this.buildFilters();
    this.bind();
    this.render();
    this.initMap();
  }

  Locator.prototype.bind = function () {
    var self = this;

    if (this.els.search) {
      this.els.search.addEventListener('input', function (event) {
        self.query = stripDiacritics(event.target.value.trim());
        self.render();
        self.fitToVisible();
      });
    }

    this.els.list.addEventListener('click', function (event) {
      var button = event.target.closest('[data-place-id]');
      if (!button) return;
      self.select(Number(button.getAttribute('data-place-id')), true);
    });
  };

  Locator.prototype.buildFilters = function () {
    if (!this.els.filters) return;

    var countries = [];
    this.places.forEach(function (place) {
      var code = (place.country || '').toUpperCase();
      if (code && countries.indexOf(code) === -1) countries.push(code);
    });

    // A single-country list needs no country filter.
    if (countries.length < 2) return;

    countries.sort();
    var self = this;
    var values = ['all'].concat(countries);

    values.forEach(function (value) {
      var chip = document.createElement('button');
      chip.type = 'button';
      chip.className = 'kekse-locator__chip';
      chip.textContent = value === 'all' ? self.labels.all : COUNTRY_LABELS[value] || value;
      chip.setAttribute('aria-pressed', value === 'all' ? 'true' : 'false');
      chip.addEventListener('click', function () {
        self.country = value;
        Array.prototype.forEach.call(self.els.filters.children, function (node) {
          node.setAttribute('aria-pressed', node === chip ? 'true' : 'false');
        });
        self.render();
        self.fitToVisible();
      });
      self.els.filters.appendChild(chip);
    });
  };

  Locator.prototype.visiblePlaces = function () {
    var self = this;
    return this.places.filter(function (place) {
      if (self.country !== 'all' && (place.country || '').toUpperCase() !== self.country) return false;
      if (self.query && place.haystack.indexOf(self.query) === -1) return false;
      return true;
    });
  };

  Locator.prototype.formatAddress = function (place) {
    var line = [place.street, [place.zip, place.city].filter(Boolean).join(' ')].filter(Boolean).join(', ');
    return line;
  };

  Locator.prototype.render = function () {
    var visible = this.visiblePlaces();
    var self = this;

    this.els.list.innerHTML = '';

    visible.forEach(function (place) {
      var li = document.createElement('li');
      li.className = 'kekse-locator__item';
      li.setAttribute('data-place-item', place.id);
      if (place.id === self.activeId) li.classList.add('kekse-locator__item--active');

      var address = self.formatAddress(place);
      // Spans, not paragraphs: a <button> may only contain phrasing content.
      li.innerHTML =
        '<button type="button" class="kekse-locator__button" data-place-id="' +
        place.id +
        '">' +
        '<span class="kekse-locator__row">' +
        self.logoHtml(place, 'kekse-locator__logo') +
        '<span class="kekse-locator__text">' +
        '<span class="kekse-locator__name">' +
        escapeHtml(place.name) +
        '</span>' +
        (address ? '<span class="kekse-locator__addr">' + escapeHtml(address) + '</span>' : '') +
        (place.note ? '<span class="kekse-locator__note">' + escapeHtml(place.note) + '</span>' : '') +
        '</span>' +
        '</span>' +
        '</button>';

      self.els.list.appendChild(li);
    });

    if (this.els.count) {
      this.els.count.textContent = visible.length + ' ' + pluralize(visible.length, this.labels);
    }

    if (this.els.empty) {
      this.els.empty.textContent = this.labels.empty || '';
      this.els.empty.hidden = visible.length !== 0;
    }

    this.syncMarkers(visible);
  };

  Locator.prototype.initMap = function () {
    if (this.map) return;
    if (!this.els.map || typeof window.L === 'undefined') return;

    var style = this.root.getAttribute('data-map-style') || 'osm';
    var tiles = TILES[style] || TILES.osm;

    this.map = window.L.map(this.els.map, {
      scrollWheelZoom: false,
      zoomControl: true,
      attributionControl: true
    });

    window.L.tileLayer(tiles.url, tiles.options).addTo(this.map);

    // Wheel-zoom only after a deliberate click, so the page keeps scrolling normally.
    var map = this.map;
    this.map.on('click', function () {
      map.scrollWheelZoom.enable();
    });
    this.map.on('mouseout', function () {
      map.scrollWheelZoom.disable();
    });

    this.createMarkers();
    this.fitToVisible(true);
    this.watchForSize();
  };

  // A map built while its container has no width (hidden tab, collapsed parent,
  // theme editor re-render) lays out against a 0px viewport and stays blank.
  // Recompute once the container actually has a size.
  Locator.prototype.watchForSize = function () {
    var self = this;
    if (!this.els.map || typeof ResizeObserver === 'undefined') return;

    var observer = new ResizeObserver(function () {
      if (!self.els.map.offsetWidth) return;
      self.map.invalidateSize();
      self.fitToVisible(true);
      observer.disconnect();
    });
    observer.observe(this.els.map);
  };

  Locator.prototype.createMarkers = function () {
    var self = this;

    this.places.forEach(function (place) {
      // Pin colour comes from the --kl-accent custom property set on the section,
      // so one setting drives pins, chips and links together.
      var icon = window.L.divIcon({
        className: '',
        html:
          '<span class="kekse-pin" data-pin-id="' +
          place.id +
          '"><span class="kekse-pin__dot"></span></span>',
        iconSize: [26, 26],
        iconAnchor: [13, 13],
        popupAnchor: [0, -12]
      });

      var marker = window.L.marker([place.lat, place.lng], {
        icon: icon,
        title: place.name,
        keyboard: true,
        alt: place.name
      });

      marker.bindPopup(self.popupHtml(place), { closeButton: true, maxWidth: 260 });
      marker.on('click', function () {
        self.select(place.id, false);
      });

      marker.placeId = place.id;
      self.markers.push(marker);
    });

    this.syncMarkers(this.visiblePlaces());
  };

  Locator.prototype.logoHtml = function (place, className) {
    if (!place.logo) return '';
    return (
      '<span class="' +
      className +
      '"><img src="' +
      escapeHtml(place.logo) +
      '" alt="" loading="lazy" decoding="async"></span>'
    );
  };

  Locator.prototype.popupHtml = function (place) {
    var address = this.formatAddress(place);
    var directions =
      'https://www.google.com/maps/dir/?api=1&destination=' + place.lat + ',' + place.lng;

    var links =
      '<a href="' +
      directions +
      '" target="_blank" rel="noopener">' +
      escapeHtml(this.labels.directions || 'Navigovat') +
      '</a>';

    if (place.url) {
      links +=
        '<a href="' +
        escapeHtml(place.url) +
        '" target="_blank" rel="noopener">' +
        escapeHtml(this.labels.website || 'Web') +
        '</a>';
    }

    return (
      this.logoHtml(place, 'kekse-popup__logo') +
      '<p class="kekse-popup__name">' +
      escapeHtml(place.name) +
      '</p>' +
      (address ? '<p class="kekse-popup__addr">' + escapeHtml(address) + '</p>' : '') +
      (place.note ? '<p class="kekse-popup__note">' + escapeHtml(place.note) + '</p>' : '') +
      '<p class="kekse-popup__links">' +
      links +
      '</p>'
    );
  };

  Locator.prototype.syncMarkers = function (visible) {
    if (!this.map) return;

    var visibleIds = visible.map(function (place) {
      return place.id;
    });
    var map = this.map;

    this.markers.forEach(function (marker) {
      var shouldShow = visibleIds.indexOf(marker.placeId) !== -1;
      var onMap = map.hasLayer(marker);
      if (shouldShow && !onMap) marker.addTo(map);
      if (!shouldShow && onMap) map.removeLayer(marker);
    });
  };

  Locator.prototype.fitToVisible = function (initial) {
    if (!this.map) return;

    var visible = this.visiblePlaces();
    if (!visible.length) return;

    var bounds = window.L.latLngBounds(
      visible.map(function (place) {
        return [place.lat, place.lng];
      })
    );

    var maxZoom = parseInt(this.root.getAttribute('data-zoom-max'), 10) || 11;
    this.map.fitBounds(bounds, { padding: [40, 40], maxZoom: maxZoom, animate: !initial });
  };

  Locator.prototype.select = function (id, fromList) {
    var self = this;
    this.activeId = id;

    Array.prototype.forEach.call(this.els.list.children, function (li) {
      li.classList.toggle(
        'kekse-locator__item--active',
        Number(li.getAttribute('data-place-item')) === id
      );
    });

    this.root.querySelectorAll('.kekse-pin').forEach(function (pin) {
      pin.classList.toggle('kekse-pin--active', Number(pin.getAttribute('data-pin-id')) === id);
    });

    var marker = this.markers.filter(function (m) {
      return m.placeId === id;
    })[0];

    if (marker && this.map) {
      if (fromList) {
        var targetZoom = Math.max(this.map.getZoom(), 13);
        this.map.setView(marker.getLatLng(), targetZoom, { animate: true });
      }
      marker.openPopup();
    }

    if (!fromList) {
      var li = this.els.list.querySelector('[data-place-item="' + id + '"]');
      if (li && typeof li.scrollIntoView === 'function') {
        li.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      }
    }

    // Mobile: bring the map into view when a shop is picked from the list.
    if (fromList && window.matchMedia('(max-width: 899px)').matches && this.els.map) {
      this.els.map.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }

    void self;
  };

  function init(scope) {
    (scope || document).querySelectorAll('[data-kekse-locator]').forEach(function (root) {
      if (root.dataset.locatorReady === '1') return;
      root.dataset.locatorReady = '1';
      new Locator(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
